"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatPhone_1 = require("../util/formatPhone");
const deserializeString_1 = require("./deserializeString");
function deserializePhoneNumber(value) {
    return (0, formatPhone_1.formatPhoneE164)((0, deserializeString_1.deserializeString)(String(value)), true);
}
exports.default = deserializePhoneNumber;
